import type { MenuDefinition } from '@1js/acui-menu/lib/components/MenuDefinition';
import type { RibbonFlyoutAnchorProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon';
import { computedFn } from 'mobx-utils/lib/computedFn';
import loc from 'owa-localize';
import GroupStrings from 'owa-locstrings/lib/strings/ribbon_mail_groups.locstring.json';
import type { ComposeViewState } from 'owa-mail-compose-store';
import type { RibbonGroupId } from 'owa-ribbon-ids';
import { MailRibbonGroupId } from 'owa-ribbon-ids';
import { createMailAppFlyoutAnchor } from '../../../../util/createMailRibbonButton';
import { getComposeRibbonId } from 'owa-compose-ribbon-utils/lib/utils/getComposeRibbonId';

const emptyMenuDefinition: MenuDefinition = {
    sections: [],
};

export const getMLRTableFormatTabCommonGroupFlyout = computedFn(
    (
        group: RibbonGroupId,
        popoutComposeViewState: ComposeViewState | undefined
    ): RibbonFlyoutAnchorProps | undefined => {
        const isPopout: boolean = popoutComposeViewState != undefined;
        const groupId = getComposeRibbonId(group, popoutComposeViewState).toString();
        switch (group) {
            case MailRibbonGroupId.Group_Table_Structure:
                return createMailAppFlyoutAnchor(
                    groupId,
                    loc(GroupStrings.table_GroupStructure),
                    undefined /*tooltip*/,
                    isPopout,
                    emptyMenuDefinition,
                    undefined /* keytipProps */,
                    undefined /* icon */
                );

            case MailRibbonGroupId.Group_Table_Merge_Split:
                return createMailAppFlyoutAnchor(
                    groupId,
                    loc(GroupStrings.table_GroupMerge),
                    undefined /*tooltip*/,
                    isPopout,
                    emptyMenuDefinition,
                    undefined /* keytipProps */,
                    undefined /* icon */
                );

            case MailRibbonGroupId.Group_Table_Insert:
                return createMailAppFlyoutAnchor(
                    groupId,
                    loc(GroupStrings.table_GroupInsert),
                    undefined /*tooltip*/,
                    isPopout,
                    emptyMenuDefinition,
                    undefined /* keytipProps */,
                    undefined /* icon */
                );

            case MailRibbonGroupId.Group_Table_Align:
                return createMailAppFlyoutAnchor(
                    groupId,
                    loc(GroupStrings.table_GroupAlignment),
                    undefined /*tooltip*/,
                    isPopout,
                    emptyMenuDefinition,
                    undefined /* keytipProps */,
                    undefined /* icon */
                );
            case MailRibbonGroupId.Group_Table_Design:
                return createMailAppFlyoutAnchor(
                    groupId,
                    loc(GroupStrings.table_GroupTableStyles),
                    undefined /*tooltip*/,
                    isPopout,
                    emptyMenuDefinition,
                    undefined /* keytipProps */,
                    undefined /* icon */
                );
            default:
                return undefined;
        }
    }
);
